<template>
    <div class="list">
        <NavBar></NavBar>
        <div>
            <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
                <!-- <van-list v-model:loading="loading" v-model:error="error" success-text="刷新成功"  :finished="finished"  @load="onLoad" > -->
                    <van-cell is-link style="display:flex;align-items:center" v-for="(item) in list" :key="item" @click="openDetail(item)">
                        <template #title>
                            <div style="display:flex;align-items:center" >
                                <i :class="item.iconfont" style="font-size:36px;padding-left:0px"></i>
                                <div style="font-size:15px;padding-left:6px">
                                    <div style="font-weight:bold">{{item.feename}}</div>
                                    <!-- <div style="font-size:13px;color:gray">费用期:{{item.createdate}}</div> -->
                                    <div style="font-size:13px;color:gray" v-if="item.payTime">{{item.payTime.substring(0,19)}}</div>
                                </div>
                            </div>
                        </template>
                        <template #right-icon>
                            <div style="display:flex;align-items:center">
                                <!-- <div style="font-size:13px;font-weight:bold">{{item.feeamount}}</div> -->
                                <div style="font-size:13px;font-weight:bold">{{((item.feeamount*10000+item.latefees*10000+item.feeshare*10000)/10000).toFixed(2)}}</div>
                                <!-- <van-icon style="padding-left:6px" name="warning-o" class="search-icon" @click="openDetail(item)"/> -->
                            </div>
                        </template>
                    </van-cell>
                <!-- </van-list> -->
            <!-- </van-pull-refresh> -->
        </div>
        <van-dialog v-model:show="showContent" title="详情" showConfirmButton>
            <div style="padding:16px 20px;font-size:13px">
                <van-row style="line-height:20px;text-align:left">
                    <van-col v-if="detailObj.startnum!=null&&detailObj.startnum!=''" span='12'>表初：{{detailObj.startnum}}</van-col>
                    <van-col v-if="detailObj.endnum!=''&&detailObj.endnum!=null" span='12'>表末：{{detailObj.endnum}}</van-col>
                    <van-col v-if="detailObj.amount!=null" span='12'>用量：{{detailObj.amount}}</van-col>
                    <van-col span='12'>单价：{{detailObj.price}}元</van-col>
                    <van-col v-if="detailObj.feeamount!=''&&detailObj.feeamount!=null" span='12'>费用金额：{{detailObj.feeamount}}元</van-col>
                    <van-col v-if="detailObj.latefees!=null" span='12'>违约金：{{detailObj.latefees}}元</van-col>
                    <van-col v-if="detailObj.feeshare!=''&&detailObj.feeshare!=null" span='12'>分摊金额：{{detailObj.feeshare}}元</van-col>
                    <van-col v-if="detailObj.shareamount!=''&&detailObj.shareamount!=null" span='12'>分摊用量：{{detailObj.shareamount}}</van-col>
                    <van-col span='12'>建筑面积：{{detailObj.struarea}}</van-col>
                    <van-col span='12'>费用期：{{detailObj.createdate}}</van-col>
                </van-row>
            </div>
        </van-dialog>
        <van-empty v-if="isShow3" image="error" description="该房间暂无交费历史" />
    </div>
</template>

<script>
import VueCookie from 'vue-cookie'
export default {
    data() {
        return{
            showContent:false,
            detailObj:{},
            houseId:'',
            isShow3:false,
            refreshing:false,
            loading:false,
            error:false,
            finished:false,
            list:[],

        }  
    },
    beforeRouteLeave(to,from,next){
        this.$nextTick(()=>{
            if(this.showContent){
                this.showContent = false
                next(false)
            }else{
                next(true)
            }
        })
    },
    methods:{
        openDetail(item){
            this.detailObj = item
            this.showContent = true
        },
        // 获取历史订单
        getHistoryList(){
            let data={
                houseId:this.houseId,
                pageNum:1,
                pageSize:100000,
            }
            // console.log(data)
            this.$postQuery('/FeeRecord/getPaidFeeRecord', data).then((response) => {
                console.log(response)
                if(response.code==200){
                    this.list = response.data.list
                    if(this.list.length>0){
                        this.isShow3 = false
                    }else{
                        this.isShow3 = true
                    }
                    this.list.forEach((item)=>{
                        if(item.feename.indexOf('水')>-1){
                            item.iconfont='iconfont icon-shuifei blue'
                        }else if(item.feename.indexOf('电')>-1){
                            item.iconfont = 'iconfont icon-dianfei green'
                        }else if(item.feename.indexOf('车')>-1){
                            item.iconfont='iconfont icon-icon-test orange'
                        }else if(item.feename.indexOf('物业')>-1){
                            item.iconfont='iconfont icon-jiaofei yellow'
                        }else{
                            item.iconfont = 'iconfont icon-qita pink'
                        }
                    })
                }else{
                    this.isShow3 = false
                }
                
            })
        },
        onLoad(){
            let data={
                houseId:VueCookie.get('openId'),
                pageNum:1,
                pageSize:100000,
            }
            this.$postQuery('/FeeRecord/getPaidFeeRecord', data).then((response) => {
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                if(response.code==200){
                    this.list = response.data.list
                    if(this.list.length==0){
                        this.isShow3 = true
                    }else{
                        this.isShow3 = false
                    }
                    // 加载状态结束
                    this.loading = false;
                    // // // 数据全部加载完成
                    if (this.list.length >= response.data.list.length) {
                        this.finished = true;
                    }
                    this.list.forEach((item)=>{
                        if(item.feename.indexOf('水')>-1){
                            item.iconfont='iconfont icon-shuifei blue'
                        }else if(item.feename.indexOf('电')>-1){
                            item.iconfont = 'iconfont icon-dianfei green'
                        }else if(item.feename.indexOf('车')>-1){
                            item.iconfont='iconfont icon-icon-test orange'
                        }else{
                            item.iconfont = 'iconfont icon-qita yellow'
                        }
                    })
                }else{
                    this.isShow3 = false
                }
            }).catch(()=>{
                this.error = true;
                this.loading = false
            })
        },
        // onRefresh(){
        //     // 清空列表数据
        //     this.finished = false;
        //     //重新加载数据
        //     this.loading = true;
        //     this.onLoad();
        // },
        // openDetail(){

        // }
    },
    created(){
        this.houseId = this.$route.query.houseguid
        this.getHistoryList()
    }
}
</script>

<style scoped>
.green{
    color: #45b97c;
}
.yellow{
    color: rgb(104, 240, 217);
}
.orange{
    color:#f05b72;
}
.blue{
    color: rgb(141, 141, 211);
}
.pink{
    color: rgb(30, 221, 196);
}
.list {
    margin-top: 46px;
}
</style>